/**
 * Translate description: Index page for transactions
 */

import { useEffect, useContext, useState } from 'react';

import { langByCode, useLanguageContext } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';
import InfoContext from '../../context/InfoContext';
import AppProvider from '../../provider/AppProvider';

import Bread from '../../components/layout/BreadCrumbs';
import Title from '../../components/layout/Title';
import ModalDelete from '../../components/layout/ModalDelete';
import Content from './components/Content';

import { Typography } from '@mui/joy';


import { Crud } from '../../utils/crud';

const crud = new Crud('transactions');

function _Index() {
  const { t } = useLanguageContext();

  const { setInfo } = useContext(InfoContext);
  const { setListItems } = useContext(AppContext);
  const { paginator, setPaginator } = useContext(AppContext);
  const { sorting } = useContext(AppContext);
  const { filter, setFilter } = useContext(AppContext);
  const { setLoading } = useContext(AppContext);
  const { currentLang } = useContext(AppContext);

  const loadTable = async () => {
    if (!filter?.lang) return;
    setLoading(true);
    let list = await crud.get({ paginator, sorting, filter })
    if (list.is_error) {
      setInfo({ type: 'danger', show: true, message: `${t('Error')}` });
      setTimeout(() => setInfo({ show: false }), 6000)
      setLoading(false);
      return;
    }
    setLoading(false);
    setListItems(list.data);
    setPaginator({ ...paginator, totalPages: list.pages });
  }

  useEffect(() => {
    if (currentLang) setFilter({ ...filter, lang: { id: langByCode(currentLang).id } })
  }, [currentLang]);

  useEffect(() => {
    loadTable();
  }, [paginator.currentPage, filter.lang?.id, filter.lang?.operator, filter.orderid?.value, sorting, filter.user_id, filter.stores, filter.date_range?.from, filter.date_range?.to]);

  const [isHiddenInfo, setIsHiddenInfo] = useState(false);

  useEffect(() => {
    // При загрузке компонента читаем из localStorage
    const shouldHide = localStorage.getItem('transaction_info_close') === 'true';
    setIsHiddenInfo(shouldHide);
  }, []);

  return (
    <>
      <Bread path={[{ name: t("Transactions") }]} />
      <Title>
        <Typography level="h2" component="h1">{t("Transactions")}</Typography>
      </Title>
      <Content />
      <ModalDelete />
    </ >
  );
}

export default function Index() {
  return (
    <AppProvider>
      <_Index />
    </AppProvider>
  );
}